import { getMicroserviceBaseContext } from '../../constants/api-routing';

const roleplayContext = getMicroserviceBaseContext('roleplay');

export const ROLEPLAY_SERVICE = {
    getTraineeListByScenarioId: `${roleplayContext}get_trainee_list_by_scenario_id`,
    getTraineeRoleplaySummaryById: `${roleplayContext}rollplay_assignment_list_by_user`,
    roleplayListToTrainer: `${roleplayContext}rollplay_scenario_list/`,
    roleplayListToTrainee: `${roleplayContext}rollplay_assignment_list_by_user`,
    deleteScenario: `${roleplayContext}delete_rollplay_scenario`,
    assignScenario: `${roleplayContext}create_rollplay_assignment`,
    roleplayHistoryBySessionId: `${roleplayContext}get_roleplay_chat_history_by_session_id`,
    roleplayLlmResponse: `${roleplayContext}roleplay_llm_response`,
    getRoleplayFeedbackBySessionId: `${roleplayContext}get_roleplay_feedback_dynamic`,
    getRoleplayEndSessionFeedback: `${roleplayContext}roleplay_end_session_feedback_dynamic`,
    roleplayDoctorResponse: `${roleplayContext}roleplay_doctor_response`,
    roleplayCoachResponse: `${roleplayContext}roleplay_coach_response`,
    getMetadataList: `${roleplayContext}rollplay_metadata_list/`,
    createScenario: `${roleplayContext}create_rollplay_scenario`,
    generateScenarioSummary: `${roleplayContext}generate_roleplay_scenario_summary`,
    getScenarioDetail: `${roleplayContext}get_scenario_detail`,
    updateScenario: `${roleplayContext}update_rollplay_scenario`,
    getUserAvatarDetailsByUserScenario: `${roleplayContext}get_user_avatar_details_by_userscenario`,
    getTrainerFeedbackBySessionId: `${roleplayContext}get_trainer_feedback_list_by_session_id`,
    updateTrainerFeedback: `${roleplayContext}update_trainer_feedback`,
    getAvatarVoiceList: `${roleplayContext}avatar_voice_list/`,
    getAvatarVoiceListByGender: `${roleplayContext}avatar_voice_list_by_gender/`,
    doctorProfileList: `${roleplayContext}doctor_profile_list/`,
    createDoctorProfile: `${roleplayContext}create_doctor_profile`,
    deleteDoctorProfile: `${roleplayContext}delete_doctor_profile/`,
    getDoctorDetail: `${roleplayContext}get_doctor_detail/`,
    updateDoctorProfile: `${roleplayContext}update_doctor_profile/`,
    avatarImageList: `${roleplayContext}avatar_image_list/`,
    roleplayAssignedTraineeList: `${roleplayContext}roleplay_assignment_trainees`,
    deleteAssignment: `${roleplayContext}delete_rollplay_assignment`,
}
